//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbPromoStripe from '@/elements/header/promo-stripe/promo-stripe.vue'

export default {
  name: 'rb-plp-promo-stripe',
  extends: RbPromoStripe,
  props: {
    textAlign: {
      type: String,
      default: 'left', //'center'
    },
  },
  computed: {
    alignText() {
      return `--${this.textAlign}`
    },
  },
  async mounted() {
    await this.$nextTick()
    this.loading = false
  },
}
